const prefix = 'http://apimock.xuetangx.com/mock/872'
let api = {}
if (process.env.NODE_ENV !== 'production' && 0) {
  api = {
    membershipDetail: `${prefix}/api/v3/membership/detail`, // 用户会员信息
    userInfo: `http://apimock.xuetangx.com/mock/115/v2/api/web/userinfo`, // 用户信息
    membershipGroupInfo: `${prefix}/api/v3/membership/group/info`, // 所有会员权限列表
    orderCreate: `${prefix}/api/v3/membership/order/create`, // 生成订单
    orderCheck: `${prefix}/api/v3/membership/order/check`, // 查看订单是否支付
    orderDetail: `${prefix}/api/v3/membership/order/detail`, // 支付后查看订单详情
    wechatPay: `${prefix}/api/v3/membership/wechat/pay`, // 生成微信支付二维码
  }
} else {
  api = {
    membershipDetail: `/api/v3/membership/detail`, // 用户会员信息
    userInfo: `/v2/api/web/userinfo`, // 用户信息
    membershipGroupInfo: `/api/v3/membership/group/info`, // 所有会员权限列表
    orderCreate: '/api/v3/membership/order/create', // 生成订单
    orderCheck: `/api/v3/membership/order/check`, // 查看订单是否支付
    orderDetail: `/api/v3/membership/order/detail`, // 支付后查看订单详情
    wechatPay: `/api/v3/membership/wechat/pay`, // 生成微信支付二维码
  }
}
export default api